import React, { useState, useCallback, useEffect } from 'react';
import DetailWrapper from '../../../../components/CardRow/DetailWrapper';
import { Box, Checkbox, InputLabel, ListItemText, MenuItem, Select } from '@material-ui/core';
import { useIntl } from 'react-intl';
import useAppContext from '../../../../hooks/context/useAppContext';
import styled from 'styled-components';
import ButtonWrapper from '../../../../components/Button/ButtonWrapper';
import DefaultButton from '../../../../components/Button/DefaultButton';
import { usePostContractVolumeExport } from '../../hooks/api/configurationApi';

const ContractVolumeReportWrapper = styled.div`
  display: flex;
  gap: 40px;
`;

const ButtonSection = styled.div`
  margin-top: 50px;
`;

const ContractVolumeReport = () => {
  const { postContractVolumeExport, data, loading } = usePostContractVolumeExport();
  const intl = useIntl();
  const { getEnums } = useAppContext();
  const enums = getEnums();

  const [commodityList, setComodityList] = useState([]);
  const [yearList, setYearList] = useState([]);
  const [purchaseMethodList, setPurchaseMethodList] = useState([]);

  const { commodities, purchaseMethods, years } = enums;

  const onGenerateReport = useCallback(() => {
    const body = {
      contractPeriods: yearList.map((year) => year.year),
      idCommodityList: commodityList.map((comodity) => comodity.id),
      purchaseMethodList: purchaseMethodList.map((purchaseMethod) => purchaseMethod.id),
    };

    (async () => {
      await postContractVolumeExport(body);
    })();
  }, [yearList, purchaseMethodList, commodityList, postContractVolumeExport]);

  useEffect(() => {
    if (data) {
      const url = window.URL.createObjectURL(new Blob([data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'EEM_smluovy_objemy_export.xlsx');

      // Append to html link element page
      document.body.appendChild(link);

      // Start download
      link.click();

      // Clean up and remove the link
      link.parentNode.removeChild(link);
    }
  }, [data]);

  const schouldGenerateReport = () => {
    return !!commodityList.length && !!yearList.length && !!purchaseMethodList.length;
  };

  return (
    <DetailWrapper>
      <ContractVolumeReportWrapper>
        <Box>
          <InputLabel>{intl.formatMessage({ id: 'app.contracts.commodity' })}</InputLabel>

          <Select
            id="commodity"
            style={{ minWidth: 200, maxWidth: 200 }}
            multiple
            value={commodityList}
            onChange={(e) => {
              const value = e.target.value;

              if (commodityList.some((comodity) => comodity?.id === value?.id)) {
                setComodityList([...commodityList].filter((comodity) => comodity.id !== value.id));
              } else {
                setComodityList(value);
              }
            }}
            renderValue={(selected) => selected.map((x) => x.name).join(', ')}>
            {commodities.map((value) => (
              <MenuItem key={value.id} value={value}>
                <Checkbox checked={commodityList.some((comodity) => comodity?.id === value?.id)} />
                <ListItemText primary={value.name} />
              </MenuItem>
            ))}
          </Select>
        </Box>

        <Box>
          <InputLabel>{intl.formatMessage({ id: 'app.contracts.purchaseMethod' })}</InputLabel>

          <Select
            id="purchaseMethod"
            style={{ minWidth: 200, maxWidth: 200 }}
            multiple
            value={purchaseMethodList}
            onChange={(e) => {
              const value = e.target.value;

              if (purchaseMethodList.some((purchaseMethod) => purchaseMethod?.id === value?.id)) {
                setPurchaseMethodList([...purchaseMethodList].filter((purchaseMethod) => purchaseMethod.id !== value.id));
              } else {
                setPurchaseMethodList(value);
              }
            }}
            renderValue={(selected) => selected.map((x) => x.name).join(', ')}>
            {purchaseMethods.map((value) => (
              <MenuItem key={value.id} value={value}>
                <Checkbox checked={purchaseMethodList.some((purchaseMethod) => purchaseMethod?.id === value?.id)} />
                <ListItemText primary={value.name} />
              </MenuItem>
            ))}
          </Select>
        </Box>

        <Box>
          <InputLabel>{intl.formatMessage({ id: 'app.contracts.contractPeriod' })}</InputLabel>

          <Select
            id="contractPeriod"
            style={{ minWidth: 200, maxWidth: 200 }}
            multiple
            value={yearList}
            onChange={(e) => {
              const value = e.target.value;
              if (yearList.some((year) => year === value)) {
                setYearList([...yearList].filter((year) => year !== value));
              } else {
                setYearList(value);
              }
            }}
            renderValue={(selected) => selected.map((x) => x.year).join(', ')}>
            {years.map((value) => (
              <MenuItem key={value.year} value={value}>
                <Checkbox checked={yearList.some((year) => year === value)} />
                <ListItemText primary={value.year} />
              </MenuItem>
            ))}
          </Select>
        </Box>
      </ContractVolumeReportWrapper>

      <ButtonSection>
        <ButtonWrapper style={{ marginTop: 50 }}>
          <DefaultButton
            id={'save'}
            primary={true}
            disabled={!schouldGenerateReport()}
            title={'app.dataTable.toolbarIconTooltip.export'}
            onClick={() => onGenerateReport()}
            loaders={[loading]}
          />
        </ButtonWrapper>
      </ButtonSection>
    </DetailWrapper>
  );
};

ContractVolumeReport.propTypes = {};

export default ContractVolumeReport;
